import { useContext } from 'react'
import FormContext from '../context/FormContext';
import {
    Backdrop,
    Typography
} from "@mui/material";

const Loader = () => {
    const { isLodaing } = useContext(FormContext)

    return (
        <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLodaing}
        >
            {/* <span class="main__loader__icon"></span> */}
        
            <Typography
                style={{
                    position: 'absolute',
                    top: '55%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
                className="main__loader"
            >
                Loading
            </Typography>
        </Backdrop>
    )
}

export default Loader